import React, { useState } from "react";
import Switch from "./Switch";

export default function RuleItem({
  name,
  desc,
  checked,
  onToggle,
  dropdown,
  dropdownValue,
  onDropdownChange,
}) {
  const [expanded, setExpanded] = useState(false);

  const hasDropdown = typeof dropdown === "function";

  return (
    <li className="flex flex-col px-4 py-3 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-1">
          {hasDropdown && (
            <button
              onClick={() => setExpanded((e) => !e)}
              aria-label={expanded ? "Collapse" : "Expand"}
              className="focus:outline-none mr-2"
              style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <span
                style={{
                  display: "inline-block",
                  transition: "transform 0.2s",
                  transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
                  fontSize: 18,
                  color: "#999",
                }}
              >
                ▶
              </span>
            </button>
          )}
          <div className="text-gray-900 font-medium">{name}</div>
        </div>
        <Switch checked={checked} onChange={onToggle} />
      </div>
      {desc && <div className="text-xs text-gray-500 mt-1">{desc}</div>}
      {hasDropdown && expanded && (
        <div>
          {/* Render whatever the dropdown is, passing state and handler */}
          {dropdown({
            value: dropdownValue,
            onChange: onDropdownChange,
          })}
        </div>
      )}
    </li>
  );
}
